import { LoadingSpinner, Logo } from 'components/svg'

import Loading from './Loading'

export const PageLoading: React.FC = () => {
  return (
    <Loading size='screen' useBg debug='PageLoader'>
      <div className='c-flow | u-flow-space--600 u-items-center'>
        <Logo />
        <LoadingSpinner />
      </div>
    </Loading>
  )
}

export default PageLoading
